export default __webpack_public_path__ + "static/media/Elena-C1A-Module.f50efb0a.pdf";